import {
  getAboveNode,
  isType,
  PlateEditor,
  splitNodes,
  unwrapNodes,
  UnwrapNodesOptions,
  Value,
  withoutNormalizing,
} from '@udecode/plate-common';

import { ELEMENT_LINK } from '../../../plateTypes';
import { ELEMENT_ANCHOR_LINK } from '../createAnchorLinkPlugin';
import { ELEMENT_INTERLINK } from '../createInterlinkPlugin';

/** Unwrap link node. */
export const unwrapLink = <V extends Value>(
  editor: PlateEditor<V>,
  options?: UnwrapNodesOptions & {
    split?: boolean;
  },
): boolean | void => {
  return withoutNormalizing(editor, () => {
    if (options?.split) {
      const linkAboveAnchor = getAboveNode(editor, {
        at: editor.selection?.anchor,
        match: (node) =>
          isType(editor, node, [
            ELEMENT_INTERLINK,
            ELEMENT_LINK,
            ELEMENT_ANCHOR_LINK,
          ]),
      });

      // anchor in link
      if (linkAboveAnchor) {
        splitNodes(editor, {
          at: editor.selection?.anchor,
          match: (node) =>
            isType(editor, node, [
              ELEMENT_INTERLINK,
              ELEMENT_LINK,
              ELEMENT_ANCHOR_LINK,
            ]),
        });
        unwrapLink(editor, {
          at: editor.selection?.anchor,
        });
        return true;
      }

      const linkAboveFocus = getAboveNode(editor, {
        at: editor.selection?.focus,
        match: (node) =>
          isType(editor, node, [
            ELEMENT_INTERLINK,
            ELEMENT_LINK,
            ELEMENT_ANCHOR_LINK,
          ]),
      });

      // focus in link
      if (linkAboveFocus) {
        splitNodes(editor, {
          at: editor.selection?.focus,
          match: (node) =>
            isType(editor, node, [
              ELEMENT_INTERLINK,
              ELEMENT_LINK,
              ELEMENT_ANCHOR_LINK,
            ]),
        });
        unwrapLink(editor, {
          at: editor.selection?.focus,
        });
        return true;
      }
    }

    unwrapNodes(editor, {
      match: (node) =>
        isType(editor, node, [
          ELEMENT_INTERLINK,
          ELEMENT_LINK,
          ELEMENT_ANCHOR_LINK,
        ]),
      ...options,
    });
  });
};
